// Skripte der B2B-Seite (Slider, Erklaerpunkte, Fotovorschau, Anfrageformular)

(function(){
  // Vorschau und Ladeanzeige der Fotogravur in die rechte Spalte holen
  var spalte = document.getElementById('nmFotoVorschau');
  var rahmen = document.querySelector('.fotorahmen');
  var platz  = document.getElementById('nmFotoPlatzhalter');
  if (!spalte || !rahmen) return;

  var karte = document.getElementById('nmPreiskarte');   // bleibt immer unten

  function holen(){
    ['fg-inline-loading', 'fg-inline-preview'].forEach(function(id){
      var e = document.getElementById(id);
      if (!e || e.parentElement === spalte) return;
      if (karte) spalte.insertBefore(e, karte); else spalte.appendChild(e);
    });
  }

  // Sobald etwas angezeigt wird, verschwindet der Platzhalter
  function pruefen(){
    var an = ['fg-inline-preview', 'fg-inline-loading'].some(function(id){
      var e = document.getElementById(id);
      return e && getComputedStyle(e).display !== 'none';
    });
    if (platz) platz.style.display = an ? 'none' : '';
  }

  holen();
  pruefen();
  new MutationObserver(function(){ holen(); pruefen(); })
    .observe(rahmen, {childList:true, subtree:true, attributes:true,
                      attributeFilter:['style','class']});
})();

(function(){
  // Erklaerpunkte: am Handy antippen, am Rechner mit der Maus darueberfahren
  document.querySelectorAll('.nmb .punkt').forEach(function(k){
    k.addEventListener('click', function(e){
      e.preventDefault();
      var gruppe = k.parentElement;
      var offen = gruppe.classList.contains('offen');
      document.querySelectorAll('.nmb .punktgruppe.offen').forEach(function(g){ g.classList.remove('offen'); });
      var feld = document.getElementById('nmPunktInfo');
      if (offen) {
        if (feld) feld.innerHTML = '';
      } else {
        gruppe.classList.add('offen');
        if (feld) feld.innerHTML = gruppe.querySelector('.blase').innerHTML;
      }
    });
  });
  document.addEventListener('click', function(e){
    if (e.target.closest('.punkt')) return;
    document.querySelectorAll('.nmb .punktgruppe.offen').forEach(function(g){ g.classList.remove('offen'); });
    var feld = document.getElementById('nmPunktInfo');
    if (feld) feld.innerHTML = '';
  });
})();

(function(){
  // Am Handy laeuft das Teilebild seitlich weiter, als der Bildschirm breit ist.
  // Hinweis, Kante und Fortschrittsbalken machen das sichtbar.
  var bild = document.getElementById('nmTeilebild');
  var balken = document.getElementById('nmWischBalken');
  var hinweis = document.getElementById('nmWischHinweis');
  if (!bild || !balken) return;
  var kasten = bild.closest('.teilebox');
  var beruehrt = false;

  function zeichnen(){
    var weite = bild.scrollWidth - bild.clientWidth;
    if (weite <= 4) {                       // passt komplett, kein Wischen noetig
      if (hinweis) hinweis.classList.add('weg');
      if (kasten) kasten.classList.add('ende');
      return;
    }
    var anteil = bild.clientWidth / bild.scrollWidth;
    var lauf = bild.scrollLeft / weite;
    balken.style.width = (anteil * 100).toFixed(1) + '%';
    balken.style.transform = 'translateX(' + (lauf * (100 / anteil - 100)).toFixed(1) + '%)';
    if (kasten) kasten.classList.toggle('ende', lauf > 0.97);
    if (hinweis && beruehrt) hinweis.classList.toggle('weg', bild.scrollLeft > 24);
  }

  bild.addEventListener('scroll', function(){ beruehrt = true; zeichnen(); }, {passive:true});
  window.addEventListener('resize', zeichnen);
  var b = bild.querySelector('img');
  if (b && !b.complete) b.addEventListener('load', zeichnen);
  zeichnen();
})();

(function(){
  var spur = document.getElementById('nmSpur');
  if (!spur) return;
  var folien = spur.querySelectorAll('.folie');
  var punkte = document.getElementById('nmPunkte');
  var slider = spur.closest('.slider');

  folien.forEach(function(_, i){
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', 'Beispiel ' + (i+1));
    b.addEventListener('click', function(){ zeige(i); });
    punkte.appendChild(b);
  });

  function aktiv(){ return Math.round(spur.scrollLeft / spur.clientWidth); }

  function zeige(i, sanft){
    var n = folien.length;
    var umlauf = (i < 0 || i > n - 1);
    i = ((i % n) + n) % n;                       // hinten raus, vorne wieder rein
    spur.scrollTo({ left: i * spur.clientWidth,
                    behavior: (umlauf || sanft === false) ? 'auto' : 'smooth' });
    setTimeout(markiere, umlauf ? 30 : 120);
  }

  function markiere(){
    var i = aktiv();
    punkte.querySelectorAll('button').forEach(function(b, j){
      b.setAttribute('aria-current', j === i ? 'true' : 'false');
    });
  }

  slider.querySelector('.pfeil.links').addEventListener('click', function(){ zeige(aktiv()-1); });
  slider.querySelector('.pfeil.rechts').addEventListener('click', function(){ zeige(aktiv()+1); });
  spur.addEventListener('scroll', function(){
    clearTimeout(spur._t); spur._t = setTimeout(markiere, 90);
  });
  window.addEventListener('resize', function(){
    clearTimeout(spur._r); spur._r = setTimeout(function(){ zeige(aktiv(), false); }, 150);
  });
  markiere();
})();

(function(){
  var form = document.getElementById('nmAnfrage');
  if (!form) return;

  var ZIEL     = 'https://workloom.de/b2b/api/anfrage/';
  var ZIEL_CV  = 'https://workloom.de/b2b/api/bestaetigen/';
  var MAX      = 100 * 1024 * 1024;

  var eingabe   = document.getElementById('nmDateien');
  var ablage    = document.getElementById('nmAblage');
  var liste     = document.getElementById('nmDateiliste');
  var meldung   = document.getElementById('nmMeldung');
  var balken    = document.getElementById('nmBalken');
  var knopf     = document.getElementById('nmSenden');
  var fertig    = document.getElementById('nmFertig');
  var kopf      = document.getElementById('nmFormularKopf');
  var zeichen   = document.getElementById('nmZeichen');
  var gewaehlt  = [];

  function lesbar(b){
    if (b < 1024) return b + ' B';
    if (b < 1024*1024) return (b/1024).toFixed(0) + ' KB';
    return (b/1024/1024).toFixed(1) + ' MB';
  }
  function summe(){ return gewaehlt.reduce(function(n,d){ return n + d.size; }, 0); }

  function sage(text){
    meldung.textContent = text || '';
    meldung.classList.toggle('sichtbar', !!text);
  }

  function zeichneListe(){
    liste.innerHTML = '';
    gewaehlt.forEach(function(d, i){
      var zeile = document.createElement('div');
      zeile.className = 'dateizeile';
      var name = document.createElement('span');
      name.className = 'dname'; name.textContent = d.name;
      var gr = document.createElement('span');
      gr.className = 'dgroesse'; gr.textContent = lesbar(d.size);
      var weg = document.createElement('button');
      weg.type = 'button'; weg.innerHTML = '&times;';
      weg.setAttribute('aria-label', d.name + ' entfernen');
      weg.addEventListener('click', function(){ gewaehlt.splice(i,1); zeichneListe(); sage(''); });
      zeile.appendChild(name); zeile.appendChild(gr); zeile.appendChild(weg);
      liste.appendChild(zeile);
    });
    if (gewaehlt.length) {
      var gesamt = document.createElement('div');
      gesamt.className = 'kleingedruckt';
      gesamt.textContent = gewaehlt.length + ' Datei' + (gewaehlt.length > 1 ? 'en' : '')
                         + ', zusammen ' + lesbar(summe()) + ' von 100 MB';
      liste.appendChild(gesamt);
    }
  }

  function aufnehmen(dateien){
    Array.prototype.forEach.call(dateien, function(d){
      if (gewaehlt.length >= 10) { sage('Bitte höchstens 10 Dateien auf einmal.'); return; }
      if (summe() + d.size > MAX) { sage('Zusammen sind höchstens 100 MB möglich.'); return; }
      var doppelt = gewaehlt.some(function(v){ return v.name === d.name && v.size === d.size; });
      if (!doppelt) gewaehlt.push(d);
    });
    zeichneListe();
  }

  eingabe.addEventListener('change', function(){ aufnehmen(eingabe.files); eingabe.value = ''; });
  ['dragenter','dragover'].forEach(function(e){
    ablage.addEventListener(e, function(ev){ ev.preventDefault(); ablage.classList.add('aktiv'); });
  });
  ['dragleave','drop'].forEach(function(e){
    ablage.addEventListener(e, function(ev){ ev.preventDefault(); ablage.classList.remove('aktiv'); });
  });
  ablage.addEventListener('drop', function(ev){
    if (ev.dataTransfer && ev.dataTransfer.files) aufnehmen(ev.dataTransfer.files);
  });

  // Conversion genau einmal melden - der Schluessel wird serverseitig verbraucht,
  // ein Neuladen der Seite kann also nichts doppelt zaehlen.
  function conversionMelden(token){
    if (!token) return;
    fetch(ZIEL_CV, { method:'POST', headers:{'Content-Type':'application/json'},
                     body: JSON.stringify({ token: token }) })
      .then(function(r){ return r.json(); })
      .then(function(a){
        if (!a.melden || typeof gtag !== 'function') return;
        gtag('event', 'b2b_anfrage', {
          value: a.wert, currency: a.waehrung, transaction_id: a.vorgang
        });
        if (window.NM_ADS_CONVERSION) {
          gtag('event', 'conversion', {
            send_to: window.NM_ADS_CONVERSION, value: a.wert,
            currency: a.waehrung, transaction_id: a.vorgang
          });
        }
      })
      .catch(function(){ /* Messung darf den Kunden nie stoeren */ });
  }

  form.addEventListener('submit', function(ev){
    ev.preventDefault();
    sage('');

    var name = document.getElementById('nmName').value.trim();
    var mail = document.getElementById('nmMail').value.trim();
    if (!name)                { sage('Bitte tragen Sie Ihren Namen ein.'); document.getElementById('nmName').focus(); return; }
    if (mail.indexOf('@') < 1){ sage('Bitte tragen Sie eine gültige E-Mail-Adresse ein.'); document.getElementById('nmMail').focus(); return; }

    var daten = new FormData();
    ['firma','ansprechpartner','email','telefon','menge','anlass','termin','nachricht','webseite']
      .forEach(function(feld){
        var e = form.querySelector('[name="'+feld+'"]');
        if (e) daten.append(feld, e.value);
      });
    gewaehlt.forEach(function(d){ daten.append('dateien', d, d.name); });
    daten.append('herkunft', location.href);

    // Klick-Kennungen mitschicken - der Server meldet die Conversion
    // spaeter damit an Google Ads.
    var kenn = window.nmKlickKennung || {};
    ['gclid','wbraid','gbraid'].forEach(function(n){
      if (kenn[n]) daten.append(n, kenn[n]);
    });
    daten.append('einwilligung',
      (window.nmEinwilligung && window.nmEinwilligung()) ? '1' : '0');

    knopf.disabled = true;
    knopf.textContent = 'Wird gesendet …';
    balken.classList.add('laeuft');

    var anfrage = new XMLHttpRequest();
    anfrage.open('POST', ZIEL, true);
    anfrage.upload.addEventListener('progress', function(e){
      if (e.lengthComputable) {
        balken.firstElementChild.style.width = Math.round(e.loaded / e.total * 100) + '%';
      }
    });
    anfrage.addEventListener('load', function(){
      balken.classList.remove('laeuft');
      var antwort = {};
      try { antwort = JSON.parse(anfrage.responseText); } catch(e) {}
      if (anfrage.status === 200 && antwort.ok) {
        form.style.display = 'none';
        kopf.style.display = 'none';
        fertig.classList.add('sichtbar');
        zeichen.textContent = 'Ihr Zeichen: ' + antwort.vorgang;
        fertig.scrollIntoView({ behavior:'smooth', block:'center' });
        conversionMelden(antwort.token);
      } else {
        knopf.disabled = false;
        knopf.textContent = 'Anfrage absenden';
        sage(antwort.fehler || 'Das hat leider nicht geklappt. Bitte schreiben Sie uns an kontakt@naturmacher.de.');
      }
    });
    anfrage.addEventListener('error', function(){
      balken.classList.remove('laeuft');
      knopf.disabled = false;
      knopf.textContent = 'Anfrage absenden';
      sage('Die Verbindung wurde unterbrochen. Bitte versuchen Sie es erneut oder schreiben Sie an kontakt@naturmacher.de.');
    });
    anfrage.send(daten);
  });
})();


/* Gravur-Video erst laden, wenn es in Sichtweite kommt. Die Seite ist ein
   Ads-Landeplatz - ein Video im Hintergrund wuerde sonst jeden Besuch
   2 MB kosten, auch wenn niemand so weit scrollt. */
(function(){
  var v = document.getElementById('nmGravurVideo');
  if (!v) return;

  // Wer Bewegung reduziert haben moechte, bekommt Bedienelemente statt Autostart.
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (ruhig && ruhig.matches) { v.controls = true; v.preload = 'metadata'; return; }

  if (!('IntersectionObserver' in window)) { v.preload = 'metadata'; return; }

  var beobachter = new IntersectionObserver(function(eintraege){
    eintraege.forEach(function(e){
      if (e.isIntersecting) {
        var p = v.play();
        if (p && p.catch) p.catch(function(){ v.controls = true; });
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: 0.25 });
  beobachter.observe(v);
})();


/* Google-Klick-Kennungen fuer die serverseitige Conversion-Meldung.
   Ohne gclid kann Google eine B2B-Anfrage keinem Anzeigenklick zuordnen.
   Gemeldet wird spaeter nur, wenn auch die Marketing-Einwilligung vorlag. */
/* Marketing-Einwilligung im Moment des Absendens. Beim Seitenaufbau hat
   der Besucher noch nicht am Banner geklickt - dort gefragt lautet die
   Antwort immer "nein". Ohne Einwilligungs-API wird NICHT gemeldet. */
window.nmEinwilligung = function(){
  try {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return !!(p && typeof p.marketingAllowed === 'function'
              && p.marketingAllowed() === true);
  } catch(e){ return false; }
};

window.nmKlickKennung = (function(){
  function ausUrl(name){
    var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(location.search);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function ausCookie(name){
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function speichern(name, wert){
    if (!wert) return;
    try { localStorage.setItem('nm_' + name, JSON.stringify(
      { wert: wert, zeit: Date.now() })); } catch(e){}
  }
  function gemerkt(name){
    try {
      var d = JSON.parse(localStorage.getItem('nm_' + name) || 'null');
      if (!d) return '';
      // Googles Klick-Fenster betraegt 90 Tage
      if (Date.now() - d.zeit > 90*24*3600*1000) return '';
      return d.wert;
    } catch(e){ return ''; }
  }

  var kenn = {};
  ['gclid','wbraid','gbraid'].forEach(function(n){
    var w = ausUrl(n);
    if (w) speichern(n, w);
    kenn[n] = w || gemerkt(n);
  });

  // Googles _gcl_aw-Cookie hat die Form GCL.<zeit>.<gclid>
  if (!kenn.gclid) {
    var c = ausCookie('_gcl_aw');
    if (c) { var t = c.split('.'); if (t.length >= 3) kenn.gclid = t.slice(2).join('.'); }
  }
  // wetracked legt die Kennungen ebenfalls ab - als letzte Rueckfallebene
  if (!kenn.gclid) {
    var w = ausCookie('_wtp');
    if (w) { try { var o = JSON.parse(atob(w)); if (o && o.gclid) kenn.gclid = o.gclid; } catch(e){} }
  }

  return kenn;
})();


/* Google-Ads-Tag nachladen. wetracked.io meldet Kaeufe server-zu-server und
   laedt deshalb kein AW-Tag - fuer die B2B-Anfrage fehlt im Browser aber der
   Empfaenger. Geladen wird ausschliesslich nach Marketing-Einwilligung. */
(function nmAdsTagLaden(){
  var ADS_ID = 'AW-11101961918';
  var fertig = false;

  function laden(){
    if (fertig || !window.nmEinwilligung || !window.nmEinwilligung()) return;
    if (document.querySelector('script[src*="gtag/js?id=' + ADS_ID + '"]')) {
      fertig = true; return;                    // schon vorhanden
    }
    fertig = true;
    window.dataLayer = window.dataLayer || [];
    // gtag existiert hier meist schon (von wetracked) - nicht ueberschreiben.
    if (typeof window.gtag !== 'function') {
      window.gtag = function(){ window.dataLayer.push(arguments); };
    }
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + ADS_ID;
    document.head.appendChild(s);
    window.gtag('js', new Date());
    window.gtag('config', ADS_ID);
  }

  laden();
  // Der Besucher klickt das Banner meist erst nach dem Seitenaufbau.
  document.addEventListener('visitorConsentCollected', laden);
  var versuche = 0;
  var takt = setInterval(function(){
    laden();
    if (fertig || ++versuche > 20) clearInterval(takt);
  }, 1000);

  /* ------------------------------------------------------------------
     Kurzanfrage unter dem Hero. Eigenes, schlankes Formular - sendet an
     denselben Endpunkt und meldet dieselbe Conversion wie das grosse.
     Grund: 80 % der Ads-Klicks kommen vom Handy, wo das grosse Formular
     erst nach ~20 Bildschirmen erscheint.
  ------------------------------------------------------------------ */
  (function(){
    var kf = document.getElementById('nmKurz');
    if (!kf) return;
    // Eigene Konstanten - dieser Block liegt in einer anderen IIFE als
    // das grosse Formular, ZIEL/ZIEL_CV sind dort nicht sichtbar.
    var ZIEL    = 'https://workloom.de/b2b/api/anfrage/';
    var ZIEL_CV = 'https://workloom.de/b2b/api/bestaetigen/';

    function conversionMelden(token){
      if (!token) return;
      fetch(ZIEL_CV, { method:'POST', headers:{'Content-Type':'application/json'},
                       body: JSON.stringify({ token: token }) })
        .then(function(r){ return r.json(); })
        .then(function(a){
          if (!a.melden || typeof gtag !== 'function') return;
          gtag('event', 'b2b_anfrage', {
            value: a.wert, currency: a.waehrung, transaction_id: a.vorgang
          });
          if (window.NM_ADS_CONVERSION) {
            gtag('event', 'conversion', {
              send_to: window.NM_ADS_CONVERSION, value: a.wert,
              currency: a.waehrung, transaction_id: a.vorgang
            });
          }
        })
        .catch(function(){ /* Messung darf den Kunden nie stoeren */ });
    }
    var knopf   = document.getElementById('nmKurzKnopf');
    var meldung = document.getElementById('nmKurzMeldung');
    var fertig  = document.getElementById('nmKurzFertig');
    var zeichen = document.getElementById('nmKurzZeichen');

    kf.addEventListener('submit', function(ev){
      ev.preventDefault();
      meldung.textContent = '';
      var name = kf.querySelector('[name=ansprechpartner]').value.trim();
      var mail = kf.querySelector('[name=email]').value.trim();
      if (!name) { meldung.textContent = 'Bitte tragen Sie Ihren Namen ein.'; return; }
      if (mail.indexOf('@') < 1) { meldung.textContent = 'Bitte tragen Sie eine gültige E-Mail-Adresse ein.'; return; }

      var daten = new FormData();
      ['firma','ansprechpartner','email','menge','webseite'].forEach(function(f){
        var e = kf.querySelector('[name="'+f+'"]');
        if (e) daten.append(f, e.value);
      });
      daten.append('nachricht', 'Kurzanfrage über das Formular im Seitenkopf.');
      daten.append('herkunft', location.href);
      var kenn = window.nmKlickKennung || {};
      ['gclid','wbraid','gbraid'].forEach(function(n){
        if (kenn[n]) daten.append(n, kenn[n]);
      });
      daten.append('einwilligung',
        (window.nmEinwilligung && window.nmEinwilligung()) ? '1' : '0');

      knopf.disabled = true;
      knopf.textContent = 'Wird gesendet …';
      var a = new XMLHttpRequest();
      a.open('POST', ZIEL, true);
      a.addEventListener('load', function(){
        var antwort = {};
        try { antwort = JSON.parse(a.responseText); } catch(e) {}
        if (a.status === 200 && antwort.ok) {
          kf.style.display = 'none';
          fertig.classList.add('sichtbar');
          zeichen.textContent = 'Ihr Zeichen: ' + antwort.vorgang;
          conversionMelden(antwort.token);
        } else {
          knopf.disabled = false;
          knopf.textContent = 'Angebot anfordern';
          meldung.textContent = antwort.fehler
            || 'Das hat leider nicht geklappt. Bitte schreiben Sie an kontakt@naturmacher.de.';
        }
      });
      a.addEventListener('error', function(){
        knopf.disabled = false;
        knopf.textContent = 'Angebot anfordern';
        meldung.textContent = 'Verbindung unterbrochen. Bitte erneut versuchen.';
      });
      a.send(daten);
    });

    /* Leiste ausblenden, sobald das Kurzformular im Blick ist */
    var leiste = document.getElementById('nmLeiste');
    var ziel = document.getElementById('kurzanfrage');
    if (leiste && ziel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(e){
        leiste.style.visibility = e[0].isIntersecting ? 'hidden' : 'visible';
      }, { threshold: 0.25 }).observe(ziel);
    }
  })();

})();
